import React, {memo} from 'react';
import {Link} from 'gatsby';
import './styles.scss';

const Footer = () => {
  return (
    <footer className="footer navbar">
      <div className="row">
        <div className="d-none d-md-block col-md-4 footer-right">&copy; {new Date().getFullYear()} TextReader.ai</div>
        <div className="col-md-8 footer-left">
          <Link to="/contact/" style={{whiteSpace: 'nowrap'}}>
            Contact us
          </Link>
          <Link to="/terms-of-use/" style={{whiteSpace: 'nowrap'}}>
            Terms of Service
          </Link>
          <Link to="/privacy-policy/" style={{whiteSpace: 'nowrap'}}>
            Privacy Policy
          </Link>
        </div>
        <div className="d-block d-md-none text-center footer-right mt-2">
          <div className="py-1" dir="ltr">
            &copy; {new Date().getFullYear()} TextReader.ai
          </div>
        </div>
      </div>
    </footer>
  );
};

export default memo(Footer);
